// 为图片添加压缩后缀
const addImgSuffix = function (val) {
    if (val.indexOf('aliyun') === -1 || val.indexOf('x-oss-process=style/yinzhilv-default') > -1) {
        return val
    } else {
        return val + '?x-oss-process=style/yinzhilv-default'
    }
}

export default addImgSuffix